import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const PieSolidIcon = createIcon(
  'PieSolid',
  <path d="M11,3.18 L11,20.82 C11,21.46 10.41,21.94 9.79,21.8 C5.32,20.8 2,16.79 2,12 C2,7.21 5.32,3.2 9.79,2.2 C10.41,2.06 11,2.54 11,3.18 Z M13.03,3.18 L13.03,9.99 C13.03,10.54 13.48,10.99 14.03,10.99 L20.82,10.99 C21.46,10.99 21.94,10.4 21.8,9.77 C20.95,6.01 18,3.05 14.25,2.2 C13.62,2.06 13.03,2.54 13.03,3.18 Z M13.03,14.01 L13.03,20.82 C13.03,21.46 13.62,21.94 14.25,21.8 C18.01,20.95 20.96,17.98 21.81,14.22 C21.95,13.6 21.46,13 20.83,13 L14.04,13 C13.48,13.01 13.03,13.46 13.03,14.01 Z" />
);

export default PieSolidIcon;
